// Disable input select zoom on iPhone. It still lets the user zoom manually
if (/(iPhone|iPod)/g.test(window.navigator.userAgent)) {
  const viewport = document.querySelector('meta[name=viewport]');
  viewport.setAttribute(
    'content',
    'width=device-width, initial-scale=1.0, maximum-scale=1.0, viewport-fit=cover'
  );
}
